import PropTypes from 'prop-types'
import Type from 'components/Type'
import { text as textColor } from 'theme/palette'

const Optional = ({ optionalLabel }) => (
  <Type
    variant="labelSubAtomicMedium"
    inline
    px={0.5}
    style={{
      textTransform: 'none',
      letterSpacing: 0,
    }}
  >
    ({optionalLabel || 'optional'})
  </Type>
)

const Label = ({
  color,
  variant,
  optional,
  optionalLabel,
  children,
  ...props
}) => (
  <Type variant={variant} color={color} {...props}>
    {children}
    {(optional || optionalLabel) && <Optional optionalLabel={optionalLabel} />}
  </Type>
)

Label.propTypes = {
  optional: PropTypes.bool,
  optionalLabel: PropTypes.any,
  color: PropTypes.oneOf(Object.keys(textColor)),
  variant: PropTypes.oneOf([
    'labelMicroBoldTertiaryUpper',
    'labelSubatomicTertiary',
    'labelSmallTertiaryUpperBold',
    'labelSmallTertiaryUpper',
    'dataMicroMediumTertiaryUpper',
    'dataBoldTertiaryUpperSpaced',
    'labelSubatomicBoldTertiary',
  ]),
}

Label.defaultProps = {
  color: 'text.neutralCool_700',
  variant: 'dataMicroMediumTertiaryUpper',
}

export default Label
